export class RCPreviousYear {
  id: number;
  title: string | null;
  objectives: string | null;
  strategicAlignment: string | null;
  councilsInvolved: string | null;
  rcApplicationId: number | null;
  bidpoolCost: number | null;
  complete: number | null;

  public patchValue(value: Partial<RCPreviousYear>) {
    const { objectives, strategicAlignment, councilsInvolved, bidpoolCost, complete } = value;

    if (objectives !== undefined) this.objectives = objectives;
    if (strategicAlignment !== undefined) this.strategicAlignment = strategicAlignment;
    if (councilsInvolved !== undefined) this.councilsInvolved = councilsInvolved;
    if (bidpoolCost !== undefined) this.bidpoolCost = bidpoolCost;
    if (complete !== undefined) this.complete = complete;
  }
}
